<template>
    <div class="h-100 d-flex flex-column">
        <v-row align="center" class="mx-0 flex-grow-0" dense>
            <v-col cols="auto" class="d-flex align-center">
                <slot name="actionButton">
                    <v-btn @click="emit('click:actionButton')" v-if="actionButtonText" color="primary">
                        <v-icon v-if="actionButtonIcon" class="me-1" :icon="actionButtonIcon"></v-icon>{{ actionButtonText }}
                    </v-btn>
                </slot>
                <v-expand-x-transition group>
                    <div v-if="removeKey && selected.length">
                        <v-btn v-tooltip="'حذف'" @click="remove()" color="error" class="rounded ms-2" icon="icon-trash" variant="tonal"></v-btn>
                    </div>
                    <div v-for="(item, index) in actions.filter(x => x.enabled(selected))" :key="index">
                        <v-btn v-tooltip="item.title" @click="item.clicked(selected)" :color="item.color ?? 'secondary'" class="rounded ms-2" :icon="item.icon" variant="tonal"></v-btn>
                    </div>
                </v-expand-x-transition>
            </v-col>
            <v-spacer></v-spacer>
            <v-col order="2" order-md="1" cols="12" md="auto">
                <v-text-field
                    append-inner-icon="search"
                    class="bg-white"
                    hide-details
                    label="جستجو در این صفحه"
                    minWidth="250"
                    v-model="search"
                ></v-text-field>
            </v-col>
            <v-col cols="auto" order="1" order-md="2" v-if="Object.keys(visibleFilters).length">
                <v-badge color="error" class="ps-1" location="top right" :model-value="!!filterCount" :content="filterCount">
                    <v-btn-group class="text">
                        <v-btn v-tooltip="'جستجوی پیشرفته'" @click="filterDrawer = true" class="px-5" icon="icon-filter" color="primary"></v-btn>
                        <v-divider v-if="!!filterCount" class="mx-0" vertical></v-divider>
                        <v-btn @click="acceptFilters(true)" v-if="!!filterCount" class="px-2" color="primary">
                            <v-icon size="18" color="white">close</v-icon> حذف فیلترها
                        </v-btn>
                    </v-btn-group>
                </v-badge>
            </v-col>
            <v-col cols="auto" order="1" order-md="2" v-if="exportKey && Object.keys(exportHeaders).length">
                <v-btn v-tooltip="'خروجی اکسل'" @click="exportDialog = true" class="rounded" icon="icon-upload" color="primary"></v-btn>
            </v-col>
            <v-col cols="auto" order="1" order-md="2" v-if="additionalActionButtonText">
                <v-btn v-tooltip="additionalActionButtonText" :icon="additionalActionButtonIcon" color="primary" class="rounded" @click="emit('click:additionalActionButton')"></v-btn>
            </v-col>
            <v-col cols="auto" order="1" order-md="2" v-if="removeableHeaders.length">
                <v-btn v-tooltip="'تنظیم ستون‌های جدول'" icon="icon-settings" color="primary" class="rounded" @click="tableOptionsDialog = true"></v-btn>
            </v-col>
        </v-row>
        <div class="bg-white rounded-lg mt-4 flex-grow-1 overflow-y-auto">
            <v-data-table
                @click:row="onRowClick"
                :headers="tableHeaders"
                :filter-keys="filterableHeaders"
                :items="items"
                :loading="loading"
                :disable-sort="disableSort"
                :show-select="display.smAndUp.value && showSelect !== false"
                :search="search"
                :items-per-page="filters.perPage.value"
                :row-props="handleRowProps"
                :hide-default-header="!display.smAndUp.value"
                fixed-footer
                class="h-100"
                multi-sort
                v-model="selected"
                density="comfortable"
                hover
                hide-no-data
                no-data-text="موردی برای نمایش وجود ندارد."
                return-object
                loading-text=""
                mobile-breakpoint="sm"
            >
                <template v-slot:loading>
                    <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
                </template>
                <template v-slot:bottom>
                    <customPagination
                        class="border-t"
                        :total-items="totalItems"
                        :loading="loading"
                        v-model:page="filters.page.value"
                        v-model:perPage="filters.perPage.value"
                        @updated="acceptPagination()"
                    />
                </template>
                <template v-for="header in flatedHeaders" v-slot:[`item.${header.key}`]="{ item, value }">
                    <v-btn v-if="header.key == 'newTab'" color="primary" variant="text" v-tooltip="newTabText" @click.stop="openInNewTab(item)" size="20" icon="open_in_new"></v-btn>
                    <v-icon v-else-if="header.key == 'status'" :color="value == 'فعال' ? 'success' : 'error'" icon="icon-online"></v-icon>
                    <slot v-else :name="`item.${header.key}`" :item="item" :value="value">
                        {{  value ?? '----------' }}
                    </slot>
                </template>
            </v-data-table>
        </div>
        <v-navigation-drawer v-if="Object.keys(visibleFilters).length" v-model="filterDrawer" temporary location="left" width="400" color="#fafafa">
            <v-card tile color="transparent" class="overflow-visible">
                <v-toolbar color="white" elevation="1" class="position-sticky py-1 top-0" style="z-index: 2;">
                    <template v-slot:prepend>
                        <v-btn @click="filterDrawer = false" color="primary" icon="close"></v-btn>
                    </template>
                    <v-toolbar-title class="text-primary">جستجوی پیشرفته</v-toolbar-title>
                    <template v-slot:append>
                        <v-btn color="success" variant="flat" @click="acceptFilters()">اعمال فیلترها</v-btn>
                        <v-btn variant="tonal" icon="refresh" class="rounded mx-2 pa-2" size="xsmall" color="primary" @click="acceptFilters(true)"></v-btn>
                    </template>
                </v-toolbar>
                <div class="px-4 pt-3">
                    <template v-for="filter in visibleFilters">
                        <custom-divider
                            v-if="filter.type == 'divider'"
                            :label="filter.label"
                            class="mb-4"
                        ></custom-divider>
                        <customer-search-input
                            v-if="filter.type == 'customerSearch'"
                            :label="filter.label"
                            clearable
                            :chips="filter.multiple"
                            :multiple="filter.multiple"
                            @update:modelValue="(value) => filter?.onChange ? filter.onChange(value) : ''"
                            v-model="filter.value"
                        ></customer-search-input>
                        <datetime-input
                            v-if="filter.type == 'date'"
                            :min="filter?.min ?? ''"
                            :label="filter.label"
                            :style="filter.group ? 'width: 43%; display: inline-block' : ''"
                            @update:modelValue="(value) => filter?.onChange ? filter.onChange(value) : ''"
                            displayFormat="jYYYY-jMM-jDD"
                            :type="filter.dateType ?? 'date'"
                            clearable
                            v-model="filter.value"
                        ></datetime-input>
                        <v-text-field
                            v-if="filter.type == 'text'"
                            @update:modelValue="(value) => filter?.onChange ? filter.onChange(value) : ''"
                            :label="filter.label"
                            :style="filter.group ? 'width: 43%; display: inline-block' : ''"
                            clearable
                            v-model="filter.value"
                        ></v-text-field>
                        <v-autocomplete
                            v-if="filter.type == 'autocomplete'"
                            :label="filter.label"
                            :items="filter.items"
                            :multiple="filter.multiple"
                            :value-comparator="(a, b) => a == b"
                            @update:modelValue="(value) => filter?.onChange ? filter.onChange(value) : ''"
                            no-data-text="موردی یافت نشد!"
                            :item-title="filter.itemTitle ?? 'name'"
                            :item-value="filter.itemValue ?? 'id'"
                            v-model="filter.value"
                            autocomplete="off"
                            clearable
                        ></v-autocomplete>
                        <custom-fields-form
                            v-if="filter.type == 'customFields'"
                            transition
                            v-model="filter.value"
                            @update:modelValue="(value) => filter?.onChange ? filter.onChange(value) : ''"
                            :items="filter.items"
                            :validation="false"
                        ></custom-fields-form>
                        <v-radio-group
                            v-if="filter.type == 'radio'"
                            :label="filter.label"
                            :value-comparator="(a, b) => a == b"
                            v-model="filter.value"
                            @update:modelValue="(value) => filter?.onChange ? filter.onChange(value) : ''"
                            inline
                        >
                            <v-radio v-for="item in filter.items" :label="item.name" :value="item.id"></v-radio>
                        </v-radio-group>
                        <div v-if="filter?.group === 'start'" class="text-center mt-2" style="display: inline-block; vertical-align: top; width: 14%;">
                            <span class="px-3 py-1 text-meta bg-secondary rounded">تا</span>
                        </div>
                    </template>
                </div>
            </v-card>
        </v-navigation-drawer>
        <v-dialog v-model="tableOptionsDialog" width="350" persistent>
            <v-card max-height="80vh" tile>
                <v-toolbar color="white" elevation="1" class="position-sticky top-0" style="z-index: 2;">
                    <v-toolbar-title class="text-primary mb-0">تنظیم ستون های جدول</v-toolbar-title>
                    <template v-slot:append>
                        <v-btn @click="tableOptionsDialog = false" color="primary" icon="close"></v-btn>
                    </template>
                </v-toolbar>
                <div class="px-4 pt-3">
                    <p class="text-small mb-3 text-primary font-weight-bold">ستون های قابل نمایش</p>
                    <template v-for="item in removeableHeaders">
                        <v-checkbox
                            hide-details
                            v-model="removedHeaders[item.key]"
                            color="primary"
                            :label="item.title"
                        ></v-checkbox>
                    </template>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="exportDialog" max-width="500" persistent>
            <v-card tile max-height="85vh">
                <v-toolbar color="white" elevation="1" class="position-sticky top-0" style="z-index: 2;">
                    <v-toolbar-title class="text-primary">خروجی گرفتن از جدول</v-toolbar-title>
                    <template v-slot:append>
                        <v-btn @click="exportDialog = false" color="primary" icon="close"></v-btn>
                    </template>
                </v-toolbar>
                <div class="pa-6">
                    <p class="text-meta text-grey-darken-1">لطفا نوع خروجی مورد نظر خود را انتخاب نمایید</p>
                    <v-row justify="space-around" align="center" class="w-100 mx-0 mt-6">
                        <v-col cols="6" class="excel-export-hover text-center cursor-pointer" @click="generateExcel(false)">
                            <v-img class="mx-auto" width="45px" height="auto" src="@/assets/img/excel-export.png"></v-img>
                            <p class="text-meta mb-0 mt-4 text-grey-darken-1">خروجی اکسل صفحه</p>
                        </v-col>
                        <v-col cols="6" class="excel-export-hover text-center cursor-pointer" @click="generateExcel(true)">
                            <v-img class="mx-auto" width="45px" height="auto" src="@/assets/img/excel-export-all.png"></v-img>
                            <p class="text-meta mb-0 mt-4 text-grey-darken-1">خروجی اکسل تمام صفحات</p>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script setup>
import { useConfirm } from '@/plugins/confirm/confirm';
import { useFileDownload } from '@/plugins/utilities';
import { onBeforeMount, computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useLocalStorage } from '@vueuse/core';
import { useApi } from '@/plugins/api';
import { useToastStore } from '@/stores/toast';
import { useLoadingStore } from '@/stores/loading';
import { toRaw } from 'vue';
import { useDisplay } from 'vuetify';

const {
    actionButtonText = false,
    actionButtonIcon = false,
    additionalActionButtonText = false,
    additionalActionButtonIcon = false,
    newTabText = 'باز کردن در تب جدید',
    rowClick = () => null,
    rowProps = () => null,
    actions = [],
    filters = [],
    headers = [],
    items = [],
    totalItems = 0,
    exportKey = false,
    settingsKey = false,
    additionalExports = {},
    getAllList = () => [],
    loading = false,
    removeKey = false,
    disableSort = false,
    showSelect = false
} = defineProps([
    'actionButtonText',
    'actionButtonIcon',
    'additionalActionButtonText',
    'additionalActionButtonIcon',
    'newTabText',
    'rowClick',
    'rowProps',
    'actions',
    'filters',
    'headers',
    'items',
    'totalItems',
    'exportKey',
    'settingsKey',
    'additionalExports',
    'getAllList',
    'loading',
    'removeKey',
    'disableSort',
    'showSelect',
])
const display = useDisplay();
const toast = useToastStore();
const globalLoading = useLoadingStore();
const route = useRoute();
const router = useRouter();
const confirm = useConfirm();
const api = useApi();
const objectHelper = useObject();
const fileDownload = useFileDownload();
const selected = ref([]);
const failedDeletes = ref([]);
const exportDialog = ref(false);
const tableOptionsDialog = ref(false);
const search = ref(null);
const filterDrawer = ref(false);
const perPageStorage = settingsKey ? useLocalStorage(settingsKey + '-table-per-page', 10) : null;

const emit = defineEmits([
    'click:actionButton',
    'click:additionalActionButton',
    'deleted',
    'getList'
]);
const filteredHeaders = computed(() => {
    return headers.filter(x => !Object.hasOwn(x, 'permission') || x.permission);
});
const removeableHeaders = computed(() => {
    return filteredHeaders.value.filter(x => !Object.hasOwn(x, 'removeable') || x.removeable);
});
const removedHeaders = settingsKey ? useLocalStorage(settingsKey + '-table-columns', Object.fromEntries(removeableHeaders.value.map(x => [x.key, true])), { mergeDefaults: (storageValue, defaults) => Object.fromEntries(Object.keys(defaults).map(x => [x, Object.hasOwn(storageValue, x) ? storageValue[x] : defaults[x]])) }) : null;
const tableHeaders = computed(() => {
    return filteredHeaders.value.filter(x => (!removeableHeaders.value.some(y => y.key === x.key) || removedHeaders.value[x.key]) && (!x.hideInMobile || display.smAndUp.value));
});
const flatedHeaders = computed(() => {
    return filteredHeaders.value.map(header => {
        return Object.hasOwn(header, 'children') ? [...header.children] : [header]
    }).flat();
});
const filterableHeaders = computed(() => {
    return filteredHeaders.value.filter(x => !Object.hasOwn(x, 'filterable') || x.filterable).map(x => x.key);
});
const exportHeaders = computed(() => {
    return {...Object.fromEntries(flatedHeaders.value.filter(x => !Object.hasOwn(x, 'exportable') || x.exportable).map(x => [x.title, Object.hasOwn(x, 'exportValue') ? x.exportValue : x.value])), ...additionalExports};
});
function handleRowProps(row) {
    if (failedDeletes.length)
        return {
            style: {'background-color': failedDeletes.includes(row.item.id) ? 'rgba(168,12,12,.1) !important' : ''}
        };
    return rowProps(row);
}
function onRowClick(_, row) {
    let page = rowClick ? rowClick(row.item) : false;
    if (page && page?.fullPath)
        router.push(page.fullPath);
}
function openInNewTab(row) {
    let page = rowClick ? rowClick(row) : false;
    if (page && page.fullPath)
        window.open(page.fullPath, '_blank');
}
function remove() {
    confirm(
        `<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، گزینه${
            selected.length == 1
                ? ` <b>${selected[0].name}</b>`
                : "‌های انتخاب شده"
        } حذف خواهد شد.</p>`,
        { buttonTrueText: "حذف", buttonTrueColor: "error" }
    ).then((res) => {
        if (res){
            globalLoading.start();
            api.multipleDelete(removeKey, selected.value.map((x) => x.id)).then(async (res) => {
                if (res && res.status == "DELETED") {
                    emit('deleted');
                    emit('getList', finalFilters.value, () => {
                        failedDeletes.value = res.data.failed;
                        setTimeout(() => {
                            failedDeletes.value = [];
                        }, 5000);
                    });
                    if (!res.data.failed.length) {
                        toast.success(res.message);
                    } else if (res.data.failed.length) {
                        toast.error("به دلیل وابستگی، امکان حذف تمام ردیف‌های انتخاب شده وجود ندارد.");
                    }
                }
            }).finally(()=>{ globalLoading.finish(); selected.value = [] });
        }
    });
}

const filteredFilters = computed(() => {
    return objectHelper.filter(filters, (_, value) => !Object.hasOwn(value, 'permission') || value.permission);
});
const finalFilters = computed({
    get: () => objectHelper.filter(route.query, (key) => Object.keys(filteredFilters.value).includes(key)),
    set: (value) => { router.replace({query: value}).catch(() => {}); emit('getList', value) }
});
const visibleFilters = computed(() => {
    return objectHelper.filter(filteredFilters.value, (_, value) => value.type != 'hidden');
});
const filterCount = computed(() => {
    return Object.keys(route.query).filter(x => Object.keys(visibleFilters.value).includes(x)).length;
});
function initialFilters() {
    if (perPageStorage)
        filters.perPage.value = perPageStorage.value;
    for (const key in finalFilters.value)
        filters[key].value = finalFilters.value[key];
    acceptPagination(true);
}
function acceptFilters(reset = false) {
    filters.page.value = 1;
    if (reset)
        Object.keys(visibleFilters.value).forEach(key => { filters[key].value = filters[key]?.multiple ? [] : null; });
    finalFilters.value = objectHelper.filterWithMap(filteredFilters.value, (_, filter) => (Array.isArray(filter.value) && filter.value.length) || (!Array.isArray(filter.value) && (filter.value || filter.value === 0)), (_, filter) => toRaw(filter.value));
    filterDrawer.value = false;
}
function acceptPagination(forceReload = false) {
    if (finalFilters.value.page != filters.page.value || finalFilters.value.perPage != filters.perPage.value) {
        let newFinalFilters = {...finalFilters.value};
        newFinalFilters.page = filters.page.value;
        newFinalFilters.perPage = filters.perPage.value;
        finalFilters.value = newFinalFilters;
    } else if (forceReload) {
        emit('getList', finalFilters.value);
    }
    if (perPageStorage)
        perPageStorage.value = filters.perPage.value;
}
async function generateExcel(full) {
    globalLoading.start();
    const data = full ? await getAllList(finalFilters.value) : items;
    const xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>sheet1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>br {mso-data-placement: same-cell;}</style></head><body><table>${table}</table></body></html>';
    const xlsData = `<thead><tr>${Object.keys(exportHeaders.value).map(x => `<th>${x}</th>`).join('')}</tr></thead><tbody>${data.map(x => `<tr>${Object.values(exportHeaders.value).map(y => `<th>${y(x) ?? '----------'}</th>`).join('')}</tr>`).join('')}</tbody>`;
    globalLoading.finish();
    fileDownload(xlsTemp.replace("${table}", xlsData), `${exportKey}.xls`, 'application/vnd.ms-excel');
}

onBeforeMount(() => {
    initialFilters();
});

defineExpose({finalFilters});
</script>
<style lang="scss" scoped>
    .excel-export-hover {
        transition: all 0.3s;
        border: 2px solid transparent;
        border-radius: 4px;
        p {
            color: #757575;
            user-select: none;
        }
        .v-image {
            filter: grayscale(100%);
        }
        &:hover {
            border-color: #2877DC;
            p {
                color: #2877DC !important;
            }
            .v-image {
                filter: grayscale(0) !important;
            }
        }
    }
</style>
